import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4e2b1b3e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-page"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "top-nav"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "main-content"
};
const _hoisted_6 = {
  key: 0,
  class: "lyric-view"
};
const _hoisted_7 = {
  class: "lyric-header"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" - ");

const _hoisted_9 = {
  key: 0,
  id: "lyric"
};
const _hoisted_10 = {
  key: 1,
  class: "tip_center"
};
const _hoisted_11 = {
  class: "markBox"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  width: "20px",
  height: "20px",
  viewBox: "0 0 1024 1024"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M710.549333 384.810667a12409.045333 12409.045333 0 0 0 47.466667-0.32l8.746667-0.085334c83.989333-0.618667 141.44 67.584 126.72 150.229334L847.296 794.026667c-10.026667 56.448-63.914667 101.546667-121.130667 101.589333L298.624 896a42.730667 42.730667 0 0 1-42.666667-42.410667l-0.810666-383.978666a42.666667 42.666667 0 0 1 42.026666-42.666667l3.157334-0.064c5.226667-0.042667 11.797333-0.042667 19.626666 0 91.946667 0.768 170.88-86.698667 170.709334-170.944-0.149333-86.741333 39.786667-126.762667 106.453333-127.573333 62.250667-0.746667 106.602667 59.605333 107.349333 149.12 0.213333 26.602667-6.293333 73.237333-14.506666 107.434666 6.186667 0 13.077333-0.042667 20.586666-0.085333z m-497.706666 63.232L213.333333 874.624A21.312 21.312 0 0 1 191.786667 896H149.525333A21.333333 21.333333 0 0 1 128 874.624l0.042667-426.581333A21.269333 21.269333 0 0 1 149.44 426.666667h41.984c11.669333 0 21.418667 9.578667 21.418667 21.376z",
  fill: "#3D3D3D"
})], -1));

const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  style: {
    "transform": "rotate(180deg)"
  },
  width: "20px",
  height: "20px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M710.549333 384.810667a12409.045333 12409.045333 0 0 0 47.466667-0.32l8.746667-0.085334c83.989333-0.618667 141.44 67.584 126.72 150.229334L847.296 794.026667c-10.026667 56.448-63.914667 101.546667-121.130667 101.589333L298.624 896a42.730667 42.730667 0 0 1-42.666667-42.410667l-0.810666-383.978666a42.666667 42.666667 0 0 1 42.026666-42.666667l3.157334-0.064c5.226667-0.042667 11.797333-0.042667 19.626666 0 91.946667 0.768 170.88-86.698667 170.709334-170.944-0.149333-86.741333 39.786667-126.762667 106.453333-127.573333 62.250667-0.746667 106.602667 59.605333 107.349333 149.12 0.213333 26.602667-6.293333 73.237333-14.506666 107.434666 6.186667 0 13.077333-0.042667 20.586666-0.085333z m-497.706666 63.232L213.333333 874.624A21.312 21.312 0 0 1 191.786667 896H149.525333A21.333333 21.333333 0 0 1 128 874.624l0.042667-426.581333A21.269333 21.269333 0 0 1 149.44 426.666667h41.984c11.669333 0 21.418667 9.578667 21.418667 21.376z",
  fill: "#3D3D3D"
}, null, -1));

const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = {
  key: 1,
  class: "search-view"
};
const _hoisted_18 = {
  class: "searchBox"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode("搜索");

const _hoisted_20 = {
  key: 0,
  class: "list-empty"
};
const _hoisted_21 = {
  key: 1,
  class: "song-list"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "song-index"
};
const _hoisted_24 = {
  class: "song-info"
};
const _hoisted_25 = {
  class: "song-name"
};
const _hoisted_26 = {
  class: "song-singer"
};
const _hoisted_27 = {
  class: "song-actions"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  width: "22px",
  height: "22px",
  viewBox: "0 0 1024 1024"
};
const _hoisted_30 = ["fill", "stroke"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  key: 2,
  class: "list-empty"
};
const _hoisted_33 = {
  key: 3,
  class: "search-pagination"
};
const _hoisted_34 = {
  key: 2,
  class: "list-view"
};
const _hoisted_35 = {
  class: "list-header"
};
const _hoisted_36 = {
  class: "list-title"
};
const _hoisted_37 = ["title"];
const _hoisted_38 = {
  class: "mode-text"
};
const _hoisted_39 = {
  key: 0,
  width: "18px",
  height: "18px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M128 256h768v64H128zM128 480h512v64H128zM128 704h768v64H128z",
  fill: "#3498db"
}, null, -1));

const _hoisted_41 = [_hoisted_40];
const _hoisted_42 = {
  key: 1,
  width: "18px",
  height: "18px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512.27 139.64V0L326.09 186.18l186.18 186.18V232.73c153.6 0 279.27 125.67 279.27 279.27 0 46.54-13.96 93.09-32.58 130.33l69.82 69.82c32.58-60.51 55.85-125.67 55.85-200.15C884.64 307.2 717.07 139.64 512.27 139.64zm0 651.63c-153.6 0-279.27-125.67-279.27-279.27 0-46.55 13.96-93.09 32.58-130.33l-69.82-69.82c-32.58 60.51-55.85 125.67-55.85 200.15 0 204.8 167.56 372.36 372.36 372.36v139.64l186.18-186.18-186.18-186.18H512.27z",
  fill: "#3498db"
}, null, -1));

const _hoisted_44 = [_hoisted_43];
const _hoisted_45 = {
  key: 2,
  width: "18px",
  height: "18px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M440 51.41a42.67 42.67 0 0 1 1.96 60.29l17.37 16.3H384.43a384 384 0 0 0-103.42 753.92l-.98-.55a42.67 42.67 0 0 1 18.35 1.37v-.17a42.67 42.67 0 0 1 0-84.27v-.09A298.67 298.67 0 0 1 384.43 213.33h82.35l-26.03 24.83a42.67 42.67 0 0 0 59.01 61.7l99.93-95.57a42.67 42.67 0 0 0-.3-61.95L500.27 49.49A42.67 42.67 0 0 0 440 51.41z",
  fill: "#3498db"
}, null, -1));

const _hoisted_47 = [_hoisted_46];
const _hoisted_48 = {
  key: 3,
  width: "18px",
  height: "18px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M768.86 325.73c-48.78 0-170.41 121.18-259.23 207.08-134.66 130.24-261.86 256.8-363.67 256.8h-62.62C57.75 789.61 37 768.83 37 743.22c0-25.6 20.75-46.39 46.34-46.39h62.62c64.34 0 194.59-129.52 299.26-230.75 127.38-123.2 237.39-233.13 323.64-233.13h59.77l-63.42-61.55a46.31 46.31 0 0 1 65.47-63.86l142.71 142.5A46.31 46.31 0 0 1 987 282.83l-142.71 142.4a46.2 46.2 0 0 1-65.54-66.45l63.42-65.09h-59.77z",
  fill: "#3498db"
}, null, -1));

const _hoisted_50 = [_hoisted_49];
const _hoisted_51 = {
  key: 1,
  class: "list-empty"
};
const _hoisted_52 = {
  key: 2,
  class: "song-list"
};
const _hoisted_53 = ["onClick"];
const _hoisted_54 = {
  class: "song-index"
};
const _hoisted_55 = {
  class: "song-info"
};
const _hoisted_56 = {
  class: "song-name"
};
const _hoisted_57 = {
  class: "song-singer"
};
const _hoisted_58 = {
  key: 0,
  class: "song-extra"
};
const _hoisted_59 = {
  class: "song-actions"
};
const _hoisted_60 = ["onClick"];
const _hoisted_61 = {
  width: "22px",
  height: "22px",
  viewBox: "0 0 1024 1024"
};
const _hoisted_62 = ["fill", "stroke"];
const _hoisted_63 = ["onClick"];
const _hoisted_64 = ["onClick"];
const _hoisted_65 = {
  key: 3,
  class: "list-empty"
};
const _hoisted_66 = {
  key: 0,
  class: "player-bar"
};
const _hoisted_67 = ["src"];
const _hoisted_68 = {
  class: "player-meta"
};
const _hoisted_69 = {
  class: "player-title"
};
const _hoisted_70 = {
  class: "player-singer"
};
const _hoisted_71 = {
  class: "player-progress"
};
const _hoisted_72 = {
  class: "time-label"
};
const _hoisted_73 = ["max", "value"];
const _hoisted_74 = {
  class: "time-label"
};
const _hoisted_75 = {
  class: "player-controls"
};

const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22px",
  height: "22px",
  viewBox: "0 0 1024 1024"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M803.584 134.592c-18.176-10.048-39.936-10.112-58.112 0L192 443.008V160.128c0-17.664-14.336-32-32-32s-32 14.336-32 32v344.896c0 2.176-.64 4.224-.64 6.464s.64 4.288.64 6.464v346.112c0 17.664 14.336 32 32 32s32-14.336 32-32V579.968l553.408 308.352c9.152 5.056 19.072 7.616 29.12 7.616s19.968-2.56 29.056-7.616c18.176-10.112 28.992-28.224 28.992-48.576V183.104c0-20.224-10.816-38.336-28.992-48.576z"
})], -1));

const _hoisted_77 = [_hoisted_76];
const _hoisted_78 = {
  key: 0,
  width: "28px",
  height: "28px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M615.693 256.012h54.855v511.987h-54.855zM377.996 256.012h54.855v511.987h-54.855z"
}, null, -1));

const _hoisted_80 = [_hoisted_79];
const _hoisted_81 = {
  key: 1,
  width: "28px",
  height: "28px",
  viewBox: "0 0 1024 1024"
};

const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M453.1 665.1l222.7-128.6c13.2-7.6 17.7-24.6 10.1-37.9L452.5 358.3c-8.6-10.7-23.1-13.4-34.7-5.7-8.7 6.7-11.7 15.5-11.7 22.6v257.5c0 9.3 4.6 17.5 11.7 22.6 8.7 6.7 21 8 31 2.2z"
}, null, -1));

const _hoisted_83 = [_hoisted_82];

const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22px",
  height: "22px",
  viewBox: "0 0 1024 1024"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M192.512 899.072c-9.728-5.632-15.872-16.384-15.872-27.648V159.232c0-11.264 6.144-22.016 15.872-27.648 9.728-5.632 22.016-5.632 31.744 0l612.864 353.792c9.728 5.632 15.872 16.384 15.872 27.648s-6.144 22.016-15.872 27.648L208.896 894.464c-5.12 3.072-10.752 4.608-16.384 4.608z"
}), /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M821.76 899.072c-22.016 0-39.936-17.92-39.936-39.936V166.912c0-22.016 17.92-39.936 39.936-39.936s39.936 17.92 39.936 39.936v692.224c0 22.016-17.92 39.936-39.936 39.936z"
})], -1));

const _hoisted_85 = [_hoisted_84];
const _hoisted_86 = {
  id: "bottom_layer",
  class: "s-bottom-layer"
};
const _hoisted_87 = {
  class: "s-bottom-layer-content"
};
const _hoisted_88 = {
  class: "lh"
};

const _hoisted_89 = /*#__PURE__*/_createTextVNode("关于hej6666");

const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "lh"
}, [/*#__PURE__*/_createElementVNode("a", {
  class: "text-color",
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "湘ICP备2024099135号")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("audio", {
    id: "audio",
    ref: "audio",
    src: _ctx.src,
    onEnded: _cache[0] || (_cache[0] = $event => $setup.end_music()),
    onTimeupdate: _cache[1] || (_cache[1] = (...args) => $setup.onTimeUpdate && $setup.onTimeUpdate(...args)),
    onLoadedmetadata: _cache[2] || (_cache[2] = (...args) => $setup.onLoadedMetadata && $setup.onLoadedMetadata(...args))
  }, null, 40, _hoisted_2), [[_vShow, false]]), _createElementVNode("nav", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navTabs, tab => {
    return _openBlock(), _createElementBlock("button", {
      key: tab.key,
      class: _normalizeClass(["nav-item", {
        active: $setup.activeNav === tab.key && !$setup.showLyricView
      }]),
      onClick: $event => $setup.switchNav(tab.key)
    }, _toDisplayString(tab.label), 11, _hoisted_4);
  }), 128))]), _createElementVNode("main", _hoisted_5, [$setup.showLyricView ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
    class: "back-btn",
    onClick: _cache[3] || (_cache[3] = $event => $setup.showLyricView = false)
  }, "← 返回"), _createElementVNode("h3", null, [_createElementVNode("span", null, _toDisplayString(_ctx.title), 1), _hoisted_8, _createElementVNode("span", null, _toDisplayString(_ctx.singer), 1)])]), _createElementVNode("div", {
    class: "lyric",
    onMouseup: _cache[4] || (_cache[4] = (...args) => $setup.huaDong && $setup.huaDong(...args)),
    onMousedown: _cache[5] || (_cache[5] = (...args) => $setup.anXia && $setup.anXia(...args))
  }, [_ctx.lyric.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lyric, (lineLyric, key) => {
    return _openBlock(), _createElementBlock("p", {
      class: _normalizeClass(["lyricLine", $setup.lyricIdx == key ? 'nowLyric' : '']),
      key: key
    }, _toDisplayString(lineLyric.lineLyric), 3);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, "暂无歌词"))], 32), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.music_zan && $setup.music_zan(...args)),
    title: "点赞"
  }, _hoisted_13), _createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.music_cai && $setup.music_cai(...args)),
    title: "点踩"
  }, [(_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))])])])) : $setup.activeNav === 'search' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_input, {
    class: "searchInput",
    modelValue: $setup.searchValue,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.searchValue = $event),
    placeholder: "搜索歌手或歌名",
    onKeyup: _withKeys($setup.searchFn, ["enter"])
  }, null, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $setup.searchFn
  }, {
    default: _withCtx(() => [_hoisted_19]),
    _: 1
  }, 8, ["onClick"])]), $setup.listLoading ? (_openBlock(), _createElementBlock("div", _hoisted_20, "搜索中...")) : $setup.displayList.length ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayList, (music, key) => {
    return _openBlock(), _createElementBlock("li", {
      key: music.id,
      class: _normalizeClass(["song-item", {
        playing: $setup.isPlayingItem(music)
      }])
    }, [_createElementVNode("div", {
      class: "song-item-main",
      onClick: $event => $setup.playFromDisplayList(key)
    }, [_createElementVNode("span", _hoisted_23, _toDisplayString(key + 1), 1), _createElementVNode("div", _hoisted_24, [_createElementVNode("p", _hoisted_25, _toDisplayString(music.music_name), 1), _createElementVNode("p", _hoisted_26, _toDisplayString(music.music_singer), 1)])], 8, _hoisted_22), _createElementVNode("div", _hoisted_27, [_createElementVNode("button", {
      class: _normalizeClass(["like-btn", {
        liked: $setup.isLiked(music)
      }]),
      onClick: _withModifiers($event => $setup.toggleLike(music), ["stop"]),
      title: "喜欢"
    }, [(_openBlock(), _createElementBlock("svg", _hoisted_29, [_createElementVNode("path", {
      fill: $setup.isLiked(music) ? '#e74c3c' : 'none',
      stroke: $setup.isLiked(music) ? '#e74c3c' : '#bbb',
      "stroke-width": "60",
      d: "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.83 264.83 0 0 0-84.5-55.5A272.39 272.39 0 0 0 679.06 145c-35.2 0-69.3 6.9-101.1 20.6-31.8 13.7-60.5 33.6-84.9 58.2-24.4-24.6-53.1-44.5-84.9-58.2C377.3 151.9 343.2 145 308 145c-35.2 0-69.3 6.9-101.1 20.6a264.83 264.83 0 0 0-84.5 55.5 260.04 260.04 0 0 0-56.9 82.8c-13.7 31.9-20.6 65.7-20.6 100.9 0 35.2 6.9 69 20.6 100.9 13.4 31.1 32.6 58.9 56.9 82.8 24.3 23.8 52.5 42.4 83.4 55.5 32.3 13.7 66.9 20.6 102.8 20.6 35.9 0 70.5-6.9 102.8-20.6 30.9-13.1 59.1-31.7 83.4-55.5 24.3-23.9 43.5-51.7 56.9-82.8 13.7-31.9 20.6-65.7 20.6-100.9 0-35.2-6.9-69-20.6-100.9z"
    }, null, 8, _hoisted_30)]))], 10, _hoisted_28), _createElementVNode("button", {
      class: "add-btn",
      onClick: _withModifiers($event => $setup.addMusicList(key), ["stop"])
    }, "+ 歌单", 8, _hoisted_31)])], 2);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_32, "输入关键词搜索歌曲")), $setup.displayList.length ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_el_pagination, {
    "current-page": $setup.serCurPage,
    "onUpdate:current-page": _cache[9] || (_cache[9] = $event => $setup.serCurPage = $event),
    "page-size": $setup.pageSize,
    "onUpdate:page-size": _cache[10] || (_cache[10] = $event => $setup.pageSize = $event),
    disabled: $setup.serDisabled,
    layout: "prev, pager, next",
    total: $setup.serCount,
    onCurrentChange: $setup.handleCurrentChange
  }, null, 8, ["current-page", "page-size", "disabled", "total", "onCurrentChange"])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("h2", _hoisted_36, _toDisplayString($setup.currentNavLabel), 1), _createElementVNode("button", {
    class: "play-mode-btn",
    onClick: _cache[11] || (_cache[11] = $event => $setup.nextModel()),
    title: $setup.modeLabels[_ctx.mode_idx]
  }, [_createElementVNode("span", _hoisted_38, _toDisplayString($setup.modeLabels[_ctx.mode_idx]), 1), _ctx.mode_idx === 0 ? (_openBlock(), _createElementBlock("svg", _hoisted_39, _hoisted_41)) : _ctx.mode_idx === 1 ? (_openBlock(), _createElementBlock("svg", _hoisted_42, _hoisted_44)) : _ctx.mode_idx === 2 ? (_openBlock(), _createElementBlock("svg", _hoisted_45, _hoisted_47)) : (_openBlock(), _createElementBlock("svg", _hoisted_48, _hoisted_50))], 8, _hoisted_37)]), $setup.showAddAllBtn && $setup.displayList.length && !$setup.listLoading ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "add-all-btn",
    onClick: _cache[12] || (_cache[12] = (...args) => $setup.addAllToPlaylist && $setup.addAllToPlaylist(...args))
  }, " 全部添加到播放列表 ")) : _createCommentVNode("", true), $setup.listLoading ? (_openBlock(), _createElementBlock("div", _hoisted_51, "加载中...")) : $setup.displayList.length ? (_openBlock(), _createElementBlock("ul", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.displayList, (music, key) => {
    return _openBlock(), _createElementBlock("li", {
      key: music.id,
      class: _normalizeClass(["song-item", {
        playing: $setup.isPlayingItem(music)
      }])
    }, [_createElementVNode("div", {
      class: "song-item-main",
      onClick: $event => $setup.playFromDisplayList(key)
    }, [_createElementVNode("span", _hoisted_54, _toDisplayString(key + 1), 1), _createElementVNode("div", _hoisted_55, [_createElementVNode("p", _hoisted_56, _toDisplayString(music.music_name), 1), _createElementVNode("p", _hoisted_57, _toDisplayString(music.music_singer), 1), $setup.activeNav === 'rank' && music.hot_score != null ? (_openBlock(), _createElementBlock("p", _hoisted_58, " 热度 " + _toDisplayString(music.hot_score) + " · 👍 " + _toDisplayString(music.like_count) + " · 👎 " + _toDisplayString(music.dislike_count), 1)) : _createCommentVNode("", true)])], 8, _hoisted_53), _createElementVNode("div", _hoisted_59, [_createElementVNode("button", {
      class: _normalizeClass(["like-btn", {
        liked: $setup.isLiked(music)
      }]),
      onClick: _withModifiers($event => $setup.toggleLike(music), ["stop"]),
      title: "喜欢"
    }, [(_openBlock(), _createElementBlock("svg", _hoisted_61, [_createElementVNode("path", {
      fill: $setup.isLiked(music) ? '#e74c3c' : 'none',
      stroke: $setup.isLiked(music) ? '#e74c3c' : '#bbb',
      "stroke-width": "60",
      d: "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.83 264.83 0 0 0-84.5-55.5A272.39 272.39 0 0 0 679.06 145c-35.2 0-69.3 6.9-101.1 20.6-31.8 13.7-60.5 33.6-84.9 58.2-24.4-24.6-53.1-44.5-84.9-58.2C377.3 151.9 343.2 145 308 145c-35.2 0-69.3 6.9-101.1 20.6a264.83 264.83 0 0 0-84.5 55.5 260.04 260.04 0 0 0-56.9 82.8c-13.7 31.9-20.6 65.7-20.6 100.9 0 35.2 6.9 69 20.6 100.9 13.4 31.1 32.6 58.9 56.9 82.8 24.3 23.8 52.5 42.4 83.4 55.5 32.3 13.7 66.9 20.6 102.8 20.6 35.9 0 70.5-6.9 102.8-20.6 30.9-13.1 59.1-31.7 83.4-55.5 24.3-23.9 43.5-51.7 56.9-82.8 13.7-31.9 20.6-65.7 20.6-100.9 0-35.2-6.9-69-20.6-100.9z"
    }, null, 8, _hoisted_62)]))], 10, _hoisted_60), $setup.showAddAllBtn ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      class: "add-icon-btn",
      onClick: _withModifiers($event => $setup.addMusicList(key), ["stop"]),
      title: "添加到播放列表"
    }, "+", 8, _hoisted_63)) : _createCommentVNode("", true), $setup.activeNav === 'playlist' ? (_openBlock(), _createElementBlock("button", {
      key: 1,
      class: "del-btn",
      onClick: _withModifiers($event => $setup.delMusicFromList(key), ["stop"])
    }, "删除", 8, _hoisted_64)) : _createCommentVNode("", true)])], 2);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString($setup.emptyListText), 1)), $setup.activeNav === 'recommend' ? (_openBlock(), _createElementBlock("button", {
    key: 4,
    class: "refresh-btn",
    onClick: _cache[13] || (_cache[13] = (...args) => $setup.loadRecommendList && $setup.loadRecommendList(...args))
  }, " 换一批推荐 ")) : _createCommentVNode("", true)]))]), _ctx.title ? (_openBlock(), _createElementBlock("footer", _hoisted_66, [_createElementVNode("div", {
    class: "player-info",
    onClick: _cache[14] || (_cache[14] = $event => $setup.showLyricView = true)
  }, [_createElementVNode("img", {
    class: "player-cover",
    src: _ctx.img,
    alt: "cover"
  }, null, 8, _hoisted_67), _createElementVNode("div", _hoisted_68, [_createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.title), 1), _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.singer), 1)])]), _createElementVNode("div", _hoisted_71, [_createElementVNode("span", _hoisted_72, _toDisplayString($setup.formatTime($setup.currentTime)), 1), _createElementVNode("input", {
    type: "range",
    class: "progress-slider",
    min: "0",
    max: $setup.duration || 0,
    step: "0.1",
    value: $setup.currentTime,
    onInput: _cache[15] || (_cache[15] = (...args) => $setup.seekProgress && $setup.seekProgress(...args)),
    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
  }, null, 40, _hoisted_73), _createElementVNode("span", _hoisted_74, _toDisplayString($setup.formatTime($setup.duration)), 1)]), _createElementVNode("div", _hoisted_75, [_createElementVNode("button", {
    class: "ctrl-btn",
    onClick: _cache[17] || (_cache[17] = _withModifiers((...args) => $setup.playLast && $setup.playLast(...args), ["stop"])),
    title: "上一曲"
  }, _hoisted_77), _createElementVNode("button", {
    class: "ctrl-btn play-btn",
    onClick: _cache[18] || (_cache[18] = _withModifiers($event => $setup.setMusicState(!_ctx.status), ["stop"])),
    title: "播放/暂停"
  }, [_ctx.status ? (_openBlock(), _createElementBlock("svg", _hoisted_78, _hoisted_80)) : (_openBlock(), _createElementBlock("svg", _hoisted_81, _hoisted_83))]), _createElementVNode("button", {
    class: "ctrl-btn",
    onClick: _cache[19] || (_cache[19] = _withModifiers((...args) => $setup.playNext && $setup.playNext(...args), ["stop"])),
    title: "下一曲"
  }, _hoisted_85)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createElementVNode("p", _hoisted_88, [_createVNode(_component_router_link, {
    to: "/about"
  }, {
    default: _withCtx(() => [_hoisted_89]),
    _: 1
  })]), _hoisted_90])])]);
}